export const DAYS_IN_WEEK = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const CUTOFF_HOUR = 14;
export const MAX_MONTHS_AHEAD = 6;
